import React, { useEffect } from "react";
import { ReworthDirectory } from "@reworthrewards/directory-react-component";
import TagManager from "react-gtm-module";
import { useDirectoryConfig } from "./hooks/useDirectoryConfig";
import Footer from "./components/footer";
import Terms from "./components/terms";
import CaptionCarousel from './components/carousel/carrousel';


const App = () => {
	const { lat, lng, isLoading, isProd } = useDirectoryConfig();

	useEffect(() => {
		if (process.env.REACT_APP_STAGE === "prod") {
			// Bancoppel medicion digital GTM Property
			TagManager.initialize({
				gtmId: "GTM-5CK498X",
				dataLayerName: "CoppelDataLayer",
			});
			// Bancoppel - Ketoro GTM Property
			TagManager.initialize({
				gtmId: "GTM-TLSPTFH",
				dataLayerName: "CoppelDataLayer",
			});
			// REWORTH GTM Property
			TagManager.initialize({
				gtmId: "GTM-5VV9MKW9",
				dataLayerName: "CoppelDataLayer",
			});
		}
	}, []);

	const fiid = process.env.REACT_APP_FIID;

	const directoryProps = {
		accentColor: "#3160A6",
		fontFamily: "Circular Std Book",
		skin: "COPPEL",
		lang: "ES",
		env: process.env.REACT_APP_STAGE,
		fiid,
		gtm: true,
	};
	return (
		<>
			{/* Uncomment the following line if u wish to test CLARA's search */}
			<CaptionCarousel />
			<ReworthDirectory {...directoryProps} />
			<Terms></Terms>
			<Footer></Footer>
		</>
	);
};

export default App;
